import React, { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv';
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import PageTitle from '../../../../components/partials/PageTitle';
import { getCustomerPayment } from '../../../../redux/slice/report/reportSlice';
import ReportFilter from './ReportFilter';
import { useNavigate } from 'react-router-dom';

const CustomerPayment = () => {

    const [filterData, setFilterData] = useState();
    const [filteredItem, setFilteredItem] = useState(false)

    const CCPdfRef = useRef()
    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const navigate = useNavigate();

    const {customerOverviewData} = useSelector((state) => state.report);
    const { user } = useSelector((state) => state.auth);

    const dispatch = useDispatch()

    const processedData = customerOverviewData?.map(row => {
      const fullName = `${row.first_name} ${row.last_name}`;
      const agent = `${row.owner_lastname} ${row.owner_lastname}`;
      const poster = `${row.poster_lastname} ${row.poster_lastname}`;
  
      return { ...row, full_name: fullName, agent, poster }; // Modify status property while keeping the rest
    }); 

    const headers = [
      { label: 'Customer ID', key: 'customer_id' },
      { label: 'Full Name', key: 'full_name' },
      { label: 'Transaction Id', key: 'transaction_Id' },
      { label: 'Policy Name', key: 'Policy_name' },
      { label: 'Amount Paid', key: 'credit' },
      { label: 'Transaction Date', key: 'payment_date' },
      { label: 'Transaction Status', key: 'payment_status' },
      { label: 'Agent', key: 'agent' },
      { label: 'Posted By', key: 'poster' },
      { label: 'Office', key: 'office_name' },
    ];

    const breadcrumb = {
        from: {
          title: "Reports",
          link: "/admin/reports",
        },
        current: {
          title: "Customer Payment",
          link: null,
        },
    };

    // print table to pdf
    const generatePDF = useReactToPrint({
      content: () => CCPdfRef.current,
      documentTitle: "Customer Payment",
  });

    useEffect(() => {
      if (filteredItem) {
        if (filterData.office_id === '') {
          const updatedFilterData = {
            ...filterData,
            office_id: user?.user?.office_id
          };
          dispatch(getCustomerPayment(updatedFilterData));
        }else{
          dispatch(getCustomerPayment(filterData));
        }
      }
    }, [dispatch, filterData, filteredItem, user?.user?.office_id])

    useEffect(() => {
      if (!user_permissions?.some(permission => permission.name === 'customer report module') || !user_permissions?.some(permission => permission.name === 'customer premuin payment report')) {
        navigate('/admin/dashboard')
      }
    }, [navigate, user_permissions])
  return (
    <>
        {/* page title */}
        <PageTitle title='Customer Payment' breadcrumb={breadcrumb} />
        {/* end page title */} 
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
          <ReportFilter 
            page={'customerPayment'}
            setFilterData={setFilterData}
            setFilteredItem={setFilteredItem}
            filteredItem={filteredItem}
          />
          {customerOverviewData && <div className="row mb-3">
            <>
                <div className='d-flex justify-content-end align-items-center'>
                    <div className=' d-flex align-items-center border '>
                    <span
                        className='bg-info me-2 text-white'
                        style={{ padding: "3px" }}
                    >
                        Export to
                    </span>

                    <span
                        href='#'
                        id='btnExport'
                        className='me-1 cursor-p'
                        title='Export to Pdf'
                        onClick={generatePDF}
                    >
                        <img
                        src={pdf}
                        alt='export-pdf'
                        style={{ height: "25px" }}
                        />
                    </span>
                    {customerOverviewData ? (
                        <CSVLink
                        data={processedData}
                        headers={headers}
                        style={{ fontWeight: "bolder", cursor: "pointer" }}
                        filename='Customer Payment Report'
                        >
                        <span
                            href='#'
                            id='btnExport'
                            className='mr-1'
                            title='Export to Excel'
                        >
                            <img
                            src={excel}
                            alt='export-excel'
                            style={{ height: "25px", marginRight: "5px" }}
                            />
                        </span>
                        </CSVLink>
                    ) : null}
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className='table table-centered table-striped nowrap w-100 no-footer' ref={CCPdfRef}>
                        <thead>
                            <tr>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "100.8px" }}
                                    aria-label='Email: activate to sort column ascending'
                                >
                                  Customer Id
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "150.8px" }}
                                    aria-label='Customer: activate to sort column ascending'
                                >
                                  Name
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "164.8px" }}
                                    aria-label='Phone: activate to sort column ascending'
                                >
                                  Transaction Id
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "144.8px" }}
                                    aria-label='Phone: activate to sort column ascending'
                                >
                                  Policy Name
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "144.8px" }}
                                    aria-label='Phone: activate to sort column ascending'
                                >
                                  Amount Paid
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Transaction Date
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "90.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Transaction Status
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Agent
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Posted By
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Office
                                </th>
                            </tr>
                        </thead>
                        {customerOverviewData?.length ? <tbody>
                            {customerOverviewData?.map((item, i) => ( 
                                <tr key={i}>
                                    <td className='text-dark'>
                                        {item?.customer_id}
                                    </td>
                                    <td className='table-user'>
                                        <span
                                            className='text-body fw-semibold'
                                        >
                                            {item?.first_name} {item?.last_name}
                                        </span>
                                    </td>                                      
                                    <td className='table-user'>
                                      {item?.transaction_Id}
                                    </td>                                      
                                    <td className='table-user'>
                                      {item?.Policy_name}
                                    </td>                                      
                                    <td className='table-user'>
                                      {item?.credit}
                                    </td>                                      
                                    <td className='table-user'>
                                      {item?.payment_date}
                                    </td>        
                                    <td>{item?.transaction_type}</td>                              
                                    <td>{item?.owner_firstname} {item?.owner_lastname}</td>
                                    <td>{item?.poster_firstname} {item?.poster_lastname}</td>
                                    <td>{item?.office_name}</td>
                                </tr>
                            ))}
                        </tbody> : null}
                    </table>
                    {customerOverviewData?.length < 1 ? (
                        <h5 className='alert alert-info'>No result found!</h5>
                    ) : null}
                </div>
            </>
            </div>}
        </div>  
    </>
  )
}

export default CustomerPayment